import './TwoTabsContainer.scss';

import { ReactNode } from 'react';

const TAB1 = 1;
const TAB2 = 2;

interface Props {
  firstTabTitle: string;
  secondTabTitle: string;
  firstTabContent: ReactNode;
  secondTabContent: ReactNode;
  activeTab: number;
  setActiveTab: (index: number) => void;
}

const TwoTabsContainer = ({
  firstTabTitle,
  secondTabTitle,
  firstTabContent,
  secondTabContent,
  activeTab,
  setActiveTab,
}: Props) => {
  const className = 'c-TwoTabsContainer';

  const handleTabClick = (tab: number) => {
    if (tab !== activeTab) setActiveTab(tab);
  };

  const renderTab = (tabNumber: number, title: ReactNode) => {
    const selected = activeTab === tabNumber;
    return (
      <button
        type="button"
        aria-selected={selected ? 'true' : 'false'}
        className={`${className}__tab${
          selected ? ` ${className}__active-tab` : ''
        }`}
        data-testid={`tab-${tabNumber}-${title}`}
        onClick={() => handleTabClick(tabNumber)}
      >
        {title}
      </button>
    );
  };

  const renderContent = () => {
    return (
      <div className={`${className}__content`}>
        {activeTab === TAB1 && (
          <div className={`${className}__tab-${TAB1}-content-container`}>
            {firstTabContent}
          </div>
        )}
        {activeTab === TAB2 && (
          <div className={`${className}__tab-${TAB2}-content-container`}>
            {secondTabContent}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={className}>
      <nav className={`${className}__tabs-container`}>
        {renderTab(TAB1, firstTabTitle)}
        {renderTab(TAB2, secondTabTitle)}
      </nav>
      {renderContent()}
    </div>
  );
};

export default TwoTabsContainer;
